/* hp26 v6h: predictive search UI + light mobile scroll lock.
   Priority: working search. v6g over-locked (early pointerdown lock, body-class
   observer unlocking before [open], touchmove preventDefault, scroll freeze) and
   broke typing/results on iOS. This version only locks while [open] is set. */
(function () {
  'use strict';
  if (window.__hp26ps) return;
  window.__hp26ps = 1;

  var mqD = window.matchMedia('(min-width: 769px)');
  var lockY = 0;
  var locked = false;

  function lockScroll() {
    if (mqD.matches || locked) return;
    locked = true;
    lockY = window.scrollY || window.pageYOffset || 0;
    var sb = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.classList.add('hp26-ps-lock');
    document.body.classList.add('hp26-ps-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    if (sb > 0) {
      document.body.style.paddingRight = sb + 'px';
      document.documentElement.style.paddingRight = sb + 'px';
    }
  }

  function unlockScroll() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('hp26-ps-lock');
    document.body.classList.remove('hp26-ps-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
    document.documentElement.style.paddingRight = '';
    try {
      window.scrollTo(0, lockY);
    } catch (e) {}
  }

  function setup(ps) {
    if (ps.__hp26) return;
    ps.__hp26 = 1;
    var form = ps.querySelector('form.search');
    if (!form) return;
    var input = ps.querySelector('.js-search-input');
    var hdr =
      ps.closest('.cc-header') ||
      ps.closest('store-header') ||
      document.querySelector('store-header');
    var slot = ps.closest('.header__search') || ps.parentElement;

    // Close button (once)
    if (!form.querySelector('.hp26-ps__close')) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hp26-ps__close';
      btn.setAttribute('aria-label', 'Close search');
      btn.innerHTML =
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      form.appendChild(btn);
      btn.addEventListener('click', function () {
        if (typeof ps.close === 'function') ps.close();
        if (input) input.blur();
      });
    }

    function isOpen() {
      return ps.hasAttribute('open');
    }

    function place() {
      if (!isOpen() || !mqD.matches || !hdr) return;
      var r = hdr.getBoundingClientRect(),
        vw = document.documentElement.clientWidth,
        vh = window.innerHeight;
      var w = Math.min(1240, vw - 32),
        top = Math.max(0, Math.round(r.bottom) + 8),
        left = Math.round((vw - w) / 2);
      ps.style.setProperty('--hp26-ps-top', top + 'px');
      ps.style.setProperty('--hp26-ps-left', left + 'px');
      ps.style.setProperty('--hp26-ps-w', w + 'px');
      ps.style.setProperty('--hp26-ps-maxh', Math.max(240, vh - top - 24) + 'px');
      ps.style.setProperty('--hp26-ps-dx', '0px');
      ps.style.setProperty('--hp26-ps-dy', '0px');
      var pn = ps.querySelector('.predictive-search');
      if (pn) {
        var q = pn.getBoundingClientRect();
        var dx = left - Math.round(q.left),
          dy = top - Math.round(q.top);
        if (dx || dy) {
          ps.style.setProperty('--hp26-ps-dx', dx + 'px');
          ps.style.setProperty('--hp26-ps-dy', dy + 'px');
        }
      }
    }

    function reserveSlot(on) {
      if (!slot || mqD.matches) return;
      if (on) {
        slot.style.minHeight = Math.max(slot.offsetHeight || 0, 44) + 'px';
        slot.classList.add('hp26-ps-slot');
      } else {
        slot.style.minHeight = '';
        slot.classList.remove('hp26-ps-slot');
      }
    }

    var wasOpen = false;
    new MutationObserver(function () {
      var o = isOpen();
      if (o && !wasOpen) {
        reserveSlot(true);
        lockScroll();
      }
      if (!o && wasOpen) {
        reserveSlot(false);
        unlockScroll();
      }
      wasOpen = o;
      if (o) place();
    }).observe(ps, { attributes: true, attributeFilter: ['open', 'results'] });

    var res = ps.querySelector('.js-search-results');
    if (res) {
      new MutationObserver(function () {
        if (isOpen()) place();
      }).observe(res, { childList: true });
    }

    window.addEventListener(
      'resize',
      function () {
        place();
        if (mqD.matches) {
          reserveSlot(false);
          unlockScroll();
        } else if (isOpen()) {
          lockScroll();
          reserveSlot(true);
        }
      },
      { passive: true }
    );
    window.addEventListener('scroll', place, { passive: true });

    // Desktop only: blur closes panel
    var down = false;
    ps.addEventListener('pointerdown', function () {
      down = true;
      setTimeout(function () {
        down = false;
      }, 500);
    });
    ps.addEventListener('focusout', function (e) {
      if (!isOpen() || !mqD.matches) return;
      var to = e.relatedTarget;
      if (to && ps.contains(to)) return;
      setTimeout(function () {
        if (down || ps.contains(document.activeElement)) return;
        if (isOpen() && typeof ps.close === 'function') ps.close();
      }, 150);
    });
  }

  function init() {
    document.querySelectorAll('.hp26-hd predictive-search').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(init);
  }
})();
